import { render, staticRenderFns } from "./m-create-contact.vue?vue&type=template&id=3c83d4bf&scoped=true&lang=pug"
import script from "./m-create-contact.vue?vue&type=script&lang=js"
export * from "./m-create-contact.vue?vue&type=script&lang=js"
import style0 from "./m-create-contact.vue?vue&type=style&index=0&id=3c83d4bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83d4bf",
  null
  
)

export default component.exports